import { ActiveBorderTransportMeansType, CustomsOfficeOfTransitDeclared } from 'features/declaration/models/schemas/commonConsignmentSchemas'
import { SecurityEnumT } from 'features/declaration/models/schemas/declarationEnums'
import { CUSTOMS_OFFICE_CODE_PREFIX, DEPARTURE_OFFICE_CODE_PREFIX, removePrefix } from 'shared/ncts/common/classifier-util'
import R0789Validator from './R0789'

const ActiveBorderTransportMeansValidator = {
  getMultiplicity: (transitOffices: CustomsOfficeOfTransitDeclared[], ensRequired: boolean) => (!ensRequired
    ? R0789Validator.getActiveBorderTransportMeansMultiplicity(transitOffices)
    : 1),
  validateBorderAndDepartureOfficeMatchForOptInEnsTransits: (
    activeBorderTransportMean: ActiveBorderTransportMeansType,
    departureCustomsOffice: string | null,
    security: SecurityEnumT,
  ) => {
    if (['0', '2'].includes(security)) {
      return true
    }

    const officeAtBorder = removePrefix(activeBorderTransportMean.customsOfficeAtBorderReferenceNumber, CUSTOMS_OFFICE_CODE_PREFIX)

    return officeAtBorder === removePrefix(departureCustomsOffice, DEPARTURE_OFFICE_CODE_PREFIX)
  },
}

export default ActiveBorderTransportMeansValidator
